import { render, staticRenderFns } from "./WxTimeFrameDatePicker.vue?vue&type=template&id=1cb1f4f0"
import script from "./WxTimeFrameDatePicker.vue?vue&type=script&lang=js"
export * from "./WxTimeFrameDatePicker.vue?vue&type=script&lang=js"
import style0 from "./WxTimeFrameDatePicker.vue?vue&type=style&index=0&id=1cb1f4f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports